var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhoneSlash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 27.5,
    height: 22,
    viewBox: "0 0 27.5 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#180058;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M27.234,19.684l-6.78-5.24A7.384,7.384,0,0,0,21.312,11V8.937a.687.687,0,0,0-.687-.687h-.687a.687.687,0,0,0-.687.687V11a5.344,5.344,0,0,1-.461,2.157l-1.141-.882A4.045,4.045,0,0,0,17.875,11V4.125a4.125,4.125,0,0,0-8.25,0V6.074L1.954.145A.688.688,0,0,0,.989.266L.145,1.351a.687.687,0,0,0,.121.965L25.546,21.855a.688.688,0,0,0,.965-.121l.844-1.086a.688.688,0,0,0-.121-.965Zm-10.047.254H14.781V18.486a7.482,7.482,0,0,0,1.447-.357l-2.153-1.664a5.541,5.541,0,0,1-.874.009A5.565,5.565,0,0,1,8.423,12.1L6.187,10.369v.294a7.8,7.8,0,0,0,6.531,7.807v1.467H10.312a.687.687,0,0,0-.687.687v.687a.687.687,0,0,0,.687.687h6.875a.687.687,0,0,0,.687-.687v-.687A.687.687,0,0,0,17.187,19.937Z",
    transform: "translate(0)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneSlash);
export default __webpack_public_path__ + "static/media/phone-slash.66dcb5efd49fc65139fa6d49824505a6.svg";
export { ForwardRef as ReactComponent };